import { createClient } from "@supabase/supabase-js";

const supabase = createClient(
  "https://woeexpeqouhtojnuyueg.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndvZWV4cGVxb3VodG9qbnV5dWVnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDcwNTY0MzcsImV4cCI6MjAyMjYzMjQzN30.nreTdyMMF6nP0oiZkpLN-MP5P0tV4roDMDBeHZ_va2Y"
);

export const getLogs = async (site_uuid) => {
  const { data } = await supabase
    .from("site_report")
    .select()
    .eq("site_uuid", site_uuid)
    .limit(20)
    .order("id", { ascending: false });
  return data;
};

export const getAllLogs = async (site_uuid) => {
  const { data } = await supabase
    .from("site_report")
    .select()
    .eq("site_uuid", site_uuid)
    .order("id", { ascending: false });
  return data;
};

export const getAllSitesLogs = async (account_uuid) => {
  // ดึง site_uuid ทั้งหมดที่อยู่ภายใต้ account
  const { data: siteData } = await supabase
    .from("account_site")
    .select("site_uuid, site_name")
    .eq("account_uuid", account_uuid);
  if (!siteData?.length) return [];

  // ดึงข้อมูล logs ของทุก site พร้อมกัน
  const logsPromises = siteData.map(site => getAllLogs(site.site_uuid));
  const logsResults = await Promise.all(logsPromises);
  console.log(logsResults);
  // รวมข้อมูล logs ทั้งหมดเข้าด้วยกันและเพิ่ม site_name
  const logsWithSiteName = logsResults.flat().map(log => {
    const site = siteData.find(site => site.site_uuid === log.site_uuid);
    return {
      ...log,
      site_name: site?.site_name || ''
    };
  });
  return logsWithSiteName.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
};